<template>
  <span
    class="button-checkbox-control"
    :style="{'--color': color, '--color--rgb': hexToRGB(color)}"
    @click="$emit('toggle', !isChecked)">
    <span class="text-cut">
      <slot />
    </span>
    <input
      type="checkbox"
      :checked="isChecked">
    <span class="checkmark" />
  </span>
</template>

<script>
export default {
  name: 'ButtonCheckbox',
  model: {
    prop: 'isChecked',
    event: 'toggle',
  },
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: '#ffffff',
    },
  },
  methods: {
    hexToRGB(hex) {
      /* eslint-disable no-bitwise */
      if (hex.indexOf('#') > -1) {
        const int = parseInt(hex.replace('#', ''), 16);
        const r = (int >> 16) & 255;
        const g = (int >> 8) & 255;
        const b = int & 255;
        return [r, g, b].join();
      }

      return hex;
    },
  },
};
</script>

<style lang="scss" scoped>
$checkbox-button-color: var(--color);
$checkbox-button-color-rgb: var(--color--rgb);

.button-checkbox-control {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  color: $checkbox-button-color;
  user-select: none;
  cursor: pointer;
  min-width: 0;

  .checkmark {
    position: relative;
    display: flex;
    height: 17px;
    width: 17px;
    margin-right: 12px;
    background-color: transparent;
    border: 1px solid $checkbox-button-color;
    flex-shrink: 0;
    transition: background-color 0.16s;

    &:after {
      display: none;
      position: absolute;
      content: '';
      left: 5px;
      top: 2px;
      width: 5px;
      height: 10px;
      border: solid $checkbox-button-color;
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
    }
  }

  &:hover input ~ .checkmark {
    background-color: rgba($checkbox-button-color-rgb, 0.24);
  }

  input { display: none; }
  input:checked ~ .checkmark:after {
    display: block;
  }
}
</style>
